<template>
  <div>
    <div class="about">
      <img class="logo" src="@/assets/logo.png" alt />
      <br />
      <br />
      <div class="title">深圳有影传媒有限公司</div>
      <br />
      <br />
      <p
        class="des"
      >我们的使命是让更多影迷发现和读懂好电影，打造国内最大的新生代影迷社区、最具创造力的内容分享平台。将联合国内数千名顶尖影视内容创作者，打造万部品质影视解说作品，覆盖全国数亿影迷。让影视内容解说，成为一种时尚创新的内容消费模式。</p>
      <br />
      <p
        class="des"
      >导演的工作是将“词穷”的部分拍摄成为影像，好的解读是将影像的意蕴还原于文字。我们致力于成为一家用创新和完美主义打造有情怀产品的内容科技公司。努力让这个世界，因为我们而有一点点的不同。品质观影，就是有影；只有电影，永不散场！</p>
    </div>
    <div style="margin-top:0.3rem">
      <yd-cell-item arrow class="list-item" type="link" href="/about/details/1">
        <span slot="left">用户协议</span>
      </yd-cell-item>
      <yd-cell-item arrow class="list-item" type="link" href="/about/details/2">
        <span slot="left">侵权申诉引导</span>
      </yd-cell-item>
      <yd-cell-item arrow class="list-item" type="link" href="/about/details/3">
        <span slot="left">隐私政策</span>
      </yd-cell-item>
      <!-- <yd-button v-if="header.decodeBody.uid > 0" size="large" bgcolor="#fff" color="#E00" @click.native="goCancelAccount">注销账号</yd-button> -->
      <div style="height:1rem"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "about",
  created() {

  },
  computed: {
  },
  data() {
    return {
      header: this.$store.state.requestHeader,
    }
  },
  methods: {
    goCancelAccount() {
      this.$router.push({name:'CancelAccount'})
    }
  }
}
</script>
<style scoped>
.about {
  text-align: center;
  padding: 0.4rem;
}
.logo {
  width: 2rem;
  height: 2rem;
}
.title {
  text-align: center;
  font-size: 0.5rem;
  line-height: 0.5rem;
}
.des {
  text-align: left;
  text-indent: 0.6rem;
  font-size: 0.3rem;
  line-height: 0.5rem;
}
.list-item {
  margin-top: 0.1rem;
  background-color: #fff;
}
</style>
